import { useCallback, useEffect, useState } from 'react';

export type BrowserNotificationState = NotificationPermission | 'unsupported';

export function getNotificationState(): BrowserNotificationState {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

export function showBrowserNotification(title: string, body: string) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;

  new Notification(title, {
    body,
    icon: '/favicon.svg',
    badge: '/favicon.svg',
    tag: 'relay-message',
  });
}

export function useNotificationPermission() {
  const [permission, setPermission] = useState<BrowserNotificationState>(() =>
    typeof window === 'undefined' ? 'unsupported' : getNotificationState(),
  );

  useEffect(() => {
    setPermission(getNotificationState());
  }, []);

  const requestPermission = useCallback(async () => {
    if (!('Notification' in window)) {
      setPermission('unsupported');
      return 'unsupported' as const;
    }

    const nextPermission = await Notification.requestPermission();
    setPermission(nextPermission);
    return nextPermission;
  }, []);

  return { permission, requestPermission };
}

